import * as React from "react";
import { IInstalments } from "../../../gulp/scripts/typescript/models/IInstalments.model";
import Tracking from "../../../gulp/scripts/typescript/modules/tracking";

interface IFinanceAccordionProps {
	financeBanners: IInstalments[];
	amount: number;
}

function FinanceAccordion(props: IFinanceAccordionProps) {

	const [isOpen, setIsOpen] = React.useState(false);

	function handleToggleVisibility(e: React.MouseEvent) {
		if (!isOpen) {
			Tracking.customEvent('finance_accordion_open', { page_type: 'basket' });
		}
		setIsOpen(!isOpen);
	}

	const availableBanners = props.financeBanners.filter((item) => item.IsAvailable && item.InstalmentsMessageFormatted);

	if (!availableBanners.length) {
		return null;
	}

	return (
		<div className="c-basket__sidebar-item c-finance-banner-accordion" data-test="finance-banner-accordion">
			<button type="button" onClick={(e) => handleToggleVisibility(e)} className="c-basket__discount-label c-finance-accordion__label h2 c-accordion__title c-accordion__title--small" aria-controls="finance-container" aria-expanded={isOpen ? 'true' : 'false'} data-test="basket-finance-accordion">
				<span className="c-finance-accordion__summary-text">Buy now, pay later with </span>
				<span className="c-finance-accordion__summary-icons">
					{availableBanners.map((item) => (
						<img src={item.IconPath} alt={item.DisplayName} className="c-finance-accordion__summary-icon" data-test={`${item.DisplayName}-finance-accordion-icon`} key={item.DisplayName} />
					))}
				</span>
			</button>
			<div className={`c-accordion__content ${isOpen ? 'is-open' : ''}`} id="finance-container">
				<div className="c-accordion__content__inner">
					{props.financeBanners.map((item) => (
						<finance-banner
							provider={item.DisplayName}
							instalmentsMessage={item.InstalmentsMessageFormatted}
							legalMessage={item.LegalMessage}
							howItWorksUrl={item.HowItWorksUrl}
							iconPath={item.IconPath}
							isAvailable={item.IsAvailable}
							amount={props.amount}
							key={item.DisplayName}
						></finance-banner>
					))}
				</div>
			</div>
		</div>
	);
}

export default FinanceAccordion;
